import { Box } from "@mui/material";
import { FC } from "react";
import { HashLoader } from "react-spinners";
import "./styles.css";

const Loader: FC<{ height?: number }> = ({ height = 330 }) => {
  return (
    <Box className="loaderContainer" height={{ height }}>
      <HashLoader loading color="#31473A" />
    </Box>
  );
};

export default Loader;
